<template>
    <b-row class="text-center text-lg-left">
        <b-col lg="3" cols="6" md="6" sm="6" v-for="i in items" :key="i.id">
		<figure class="figure">
	<figcaption v-if="i.name.length<30" class="text-left figure-caption">{{ i.name }}</figcaption>
      <figcaption v-else class="text-left figure-caption">{{ i.name.substring(0,30)+"..." }}</figcaption>
            <router-link class="d-block mb-1 h-100" :to="'/video/' + i.id">
          <b-img fluid class="img-thumbnail" :src="i.logo" alt=""></b-img></router-link>
    <b-card class="mb-1">
    <b-card-text v-if="i.description.length<70" style="font-size: small">
     {{ i.description }}
    </b-card-text>
    <b-card-text v-else style="font-size: small">
     {{ i.description.substring(0,70)+"..." }}
    </b-card-text>
  </b-card>
		<div v-if="authenticated" class="progress mt-1">
  <div v-if="(i.percentage>=10 && authenticated)" class="progress-bar progress-bar-success progress-bar-striped" role="progressbar"
  :aria-valuenow="i.percentage" aria-valuemin="0" aria-valuemax="100" :style="{width: i.percentage + '%' }">
{{ i.percentage }}%
  </div>
  <div v-else class="progress-bar progress-bar-success progress-bar-striped" role="progressbar"
  :aria-valuenow="i.percentage" aria-valuemin="0" aria-valuemax="100" style="width:10%">
{{ i.percentage }}%
  </div>

</div>


</figure>
        </b-col>
    </b-row>

</template>

<script>

    export default {

        name: "Item.vue",
        props :['items','authenticated'],

    }
</script>

<style scoped>


</style>



// WEBPACK FOOTER //
// src/components/Item.vue